<template>
  <div>
    <textarea :id="id" />
  </div>
</template>

<script>
import tinymce from "tinymce/tinymce";
import "@/plugins/wysiwyg/ru.js";
import "tinymce/themes/modern/theme";
import "tinymce/skins/lightgray/skin.min.css";

import "@/plugins/wysiwyg/maxchars.js";

import "tinymce/plugins/advlist";
import "tinymce/plugins/autolink";
import "tinymce/plugins/imagetools";
import "tinymce/plugins/link";
import "tinymce/plugins/media";
import "tinymce/plugins/code";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/image";
import "tinymce/plugins/lists";
import "tinymce/plugins/preview";
import "tinymce/plugins/table";
import "tinymce/plugins/textcolor";
// import 'tinymce/plugins/wordcount'
// import 'tinymce/plugins/autosave'
// import 'tinymce/plugins/charmap'
// import 'tinymce/plugins/codesample'
// import 'tinymce/plugins/contextmenu'
// import 'tinymce/plugins/emoticons'
// import 'tinymce/plugins/fullscreen'
// import 'tinymce/plugins/hr'
// import 'tinymce/plugins/insertdatetime'
// import 'tinymce/plugins/noneditable'
import "tinymce/plugins/paste";
// import 'tinymce/plugins/print'
// import 'tinymce/plugins/searchreplace'
// import 'tinymce/plugins/tabfocus'
// import 'tinymce/plugins/template'
// import 'tinymce/plugins/textpattern'
// import 'tinymce/plugins/visualblocks'
// import 'tinymce/plugins/anchor'
// import 'tinymce/plugins/autoresize'
// import 'tinymce/plugins/bbcode'
// import 'tinymce/plugins/directionality'
// import 'tinymce/plugins/fullpage'
// import 'tinymce/plugins/help'
// import 'tinymce/plugins/importcss'
// import 'tinymce/plugins/legacyoutput'
// import 'tinymce/plugins/nonbreaking'
// import 'tinymce/plugins/pagebreak'
// import 'tinymce/plugins/save'
// import 'tinymce/plugins/spellchecker'
// import 'tinymce/plugins/toc'
// import 'tinymce/plugins/visualchars'

export default {
  name: "Wysiwyg",
  props: {
    id: {
      type: String,
      default: () => {
        return `tinymce_${Math.random().toString(16).slice(2)}`;
      },
    },
    maxLength: {
      type: Number,
      default: 0,
    },
    value: {
      type: String,
      default: "",
    },
    height: {
      type: [Number, String],
      required: false,
      default: 250,
    },
    plugins: {
      type: Array,
      default: () => {
        return [
          "advlist autolink lists link image preview",
          "code paste",
          "media table",
          "textcolor colorpicker imagetools",
          "maxchars",
        ];
      },
    },
    menubar: {
      type: String,
      default: "",
      // default: 'file edit insert view format table'
    },
    toolbar: {
      type: Array,
      default: () => [
        "formatselect bold italic underline strikethrough alignleft aligncenter alignright outdent indent blockquote undo redo removeformat subscript superscript code codesample",
        "bullist numlist link image preview media table forecolor backcolor",
      ],
    },
  },
  data() {
    return {
      content: "",
      checkerTimeout: null,
      isTyping: false,
      editor: null,
    };
  },
  watch: {
    value: function (newValue) {
      newValue = newValue || "";
      if (!this.isTyping) {
        if (this.editor !== null) {
          this.editor.setContent(newValue);
        } else {
          this.content = newValue;
        }
      }
    },
  },
  mounted() {
    this.content = this.value;
    this.init();
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  methods: {
    init() {
      const options = {
        selector: `#${this.id}`,
        skin: false,
        menubar: this.menubar,
        toolbar: this.toolbar,
        plugins: this.plugins,
        height: this.height,
        // оставляем стили доступные из редактора
        // стили font-family и т.п. отключаем
        valid_styles: {
          "*": "text-decoration text-align color background-color",
        },
        setup: (editor) => {
          editor.maxChars = this.maxLength;
        },
        init_instance_callback: this.initEditor,
      };
      tinymce.init(options);
    },
    initEditor(editor) {
      this.editor = editor;
      editor.on("KeyUp", () => {
        this.getContent();
      });
      editor.on("Change", () => {
        if (this.editor.getContent() !== this.value) {
          this.getContent();
        }
      });

      editor.setContent(this.content);
      // this.$emit('input', this.content)
    },
    getContent() {
      this.isTyping = true;
      if (this.checkerTimeout !== null) clearTimeout(this.checkerTimeout);
      this.checkerTimeout = setTimeout(() => {
        this.isTyping = false;
      }, 300);
      this.$emit("input", this.editor.getContent());
    },
  },
};
</script>
